import React from 'react';

const UpdateSampleModal = () => {
	return (
		<>
			<div className="popup-wrapper width-420-modal">
				<div className="common-popup update-sample-and-sales-modal">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-14 mb-0">Size And Color Wise Order</h3>
						</div>
						<div className="close-btn">
							<img src="/icons/close.svg" alt="close" />
						</div>
					</div>
					<div className="common-popup-body scroll-y-label">
						<div className="row">
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Project type</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Project Owner</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Comment</label>
									<input type="text" />
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2">Cancel</button>
							<button className="button size32 ml-2">Update</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default UpdateSampleModal;
